import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export const personNameValidator: ValidatorFn = (control: AbstractControl): ValidationErrors | null => {
  const firstName = control.get('firstName')?.value;
  const lastName = control.get('lastName')?.value;
  const hasName = [firstName, lastName]
    .some((value) => { return typeof value === 'string' && Boolean(value.trim()); });

  return hasName
    ? null
    : {
      personNameRequired: true,
    };
};
